import logo from "./assetsBalanceLogo.png";
import "./styles.css";

export default function Footer() {
  return (
    <div className="footer-section">
      <div className="footer-signup">
        <img src={logo} alt=""></img>
      </div>
    </div>
  );
}
